import type { Components } from '@mui/material/styles';

export default function MuiDivider(): Components['MuiDivider'] {
  return {
    styleOverrides: {
      root: {
        borderWidth: 0.5,
      },
    },
  };
}
